module.exports = __webpack_public_path__ + "static/logo-black-pro-reno-340e6eac0e7abbff142ab3f8ee1c7c38.png";